import { DisplayTable } from '@policoders/ds';
import PageHeader from '@shared/components/page-header';

import { useTechnicalSheet } from './technical-sheet.hook';

export const TechnicalSheetPage = () => {
  const { lines, tActions, tColumns, tHeaderButtons, handleEdit } = useTechnicalSheet();

  return (
    <>
      <PageHeader title="Fichas técnicas" />
      <DisplayTable
        actions={tActions}
        columns={tColumns}
        headerButtons={tHeaderButtons}
        lines={lines}
        onLineClick={handleEdit}
      />
    </>
  );
};
